import { render, staticRenderFns } from "./VueOfficeView.vue?vue&type=template&id=5fff642a&scoped=true"
import script from "./VueOfficeView.vue?vue&type=script&lang=js"
export * from "./VueOfficeView.vue?vue&type=script&lang=js"
import style0 from "./VueOfficeView.vue?vue&type=style&index=0&id=5fff642a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff642a",
  null
  
)

export default component.exports